<!--  -->
<template>
  <div class="container">
    <div class="box">
      <img src="~@/assets/images/ad/ad2/25.png" alt="" />
      <div class="btn-box">
        <a class="btn" href="https://www.wjx.top/vm/wFoDDG0.aspx">点击报名</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
  //方法集合
  methods: {},
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.box {
  position: relative;
  box-sizing: border-box;
  width: 7.5rem;
  margin: 0 auto;

  img {
    display: block;
    width: 100%;
  }
}

.btn-box {
  position: absolute;
  width: 100%;
  bottom: 1.04rem;
  box-sizing: border-box;
  padding: 0 0.43rem 0 0.53rem;

  .btn {
    display: block;
    width: 6.54rem;
    height: 0.9rem;
    background: #ffe6e2;
    box-shadow: 0px 0px 0.3rem 0px #d61d00;
    border-radius: 0.45rem;
    font-size: 0.3rem;
    font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
    font-weight: 500;
    color: #fb4529;
    text-align: center;
    line-height: 0.9rem;
  }
}
</style>